import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Plus } from 'lucide-react';

export const PageHeader = ({ title, subtitle, actionLabel, onAction, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2">
      {children}
      {actionLabel && (
        <Button onClick={onAction} className="bg-blue-600 hover:bg-blue-700">
          <Plus className="mr-1.5 h-4 w-4" /> {actionLabel}
        </Button>
      )}
    </div>
  </div>
);

const STATUS_STYLES = {
  paid: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  unpaid: 'bg-red-100 text-red-700 border-red-200',
  overdue: 'bg-red-100 text-red-700 border-red-200',
  partial: 'bg-amber-100 text-amber-700 border-amber-200',
  pending: 'bg-amber-100 text-amber-700 border-amber-200',
  draft: 'bg-slate-100 text-slate-600 border-slate-200',
  accepted: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  rejected: 'bg-slate-100 text-slate-500 border-slate-200',
  sent: 'bg-blue-100 text-blue-700 border-blue-200',
  active: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  invited: 'bg-amber-100 text-amber-700 border-amber-200',
};

export const StatusBadge = ({ status }) => (
  <Badge variant="outline" className={`rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${STATUS_STYLES[status] || 'bg-slate-100 text-slate-600'}`}>
    {status}
  </Badge>
);

export const EmptyState = ({ icon: Icon, title, subtitle }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-16 text-center">
    {Icon && <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"><Icon className="h-6 w-6 text-slate-400" /></div>}
    <p className="font-semibold text-slate-700">{title}</p>
    {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
  </div>
);

export const Card = ({ className = '', children }) => (
  <div className={`rounded-xl border border-slate-200 bg-white shadow-sm ${className}`}>{children}</div>
);
